"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsolePathForSelection = void 0;
var getConsolePathForSelection = exports.getConsolePathForSelection = function getConsolePathForSelection(type, selected) {
  if (type === 'summary') {
    return '/summary';
  }
  return "/".concat(type, "/").concat(encodeURIComponent(selected));
};
//# sourceMappingURL=paths.js.map